import { forwardRef } from 'react';
import { DialogBody } from '@/ui_v3';
import { cn, isIos } from '@/utils';
export const BuildAiModalBody = forwardRef<HTMLDivElement, {
  children?: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>>(({
  children
}, ref) => {
  const isIosDevice = isIos();
  return <DialogBody ref={ref} className={cn(isIosDevice ? 'h-[600px]' : 'h-[652px]')}>
      {children}
    </DialogBody>;
});
BuildAiModalBody.displayName = 'BuildAiModalBody';